import { Outlet } from 'react-router-dom'
import homeTheme from './theme'
import { ThemeProvider } from '@mui/material'

export default function Home() {
  return (
    <ThemeProvider theme={homeTheme}>
      <Outlet />
    </ThemeProvider>
  )
}
